import { View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout } from "@pimo/pimo-components/src/lib/layouts/drag-and-drop-layout/drag-and-drop-layout";
import { PMDonutChartCard } from "@pimo/pimo-components/src/lib/pm-components";
import { APP_RECORD_TYPES } from "vmd-types";

import { TestAppState } from "../../../app";
import { DONUT_CARD_LAYOUT, DONUT_CHART_COLORS } from "../../../constants";
import {
  getAllReportingItems,
  withTotalInTitle,
} from "../../../helpers/pages-helpers/dashboard-plugin-helpers";
import {
  countReportingItemsByRecordType,
  isRecordTypeVisible,
} from "../../../utils/filter-reporting-items-by-record-type";

const RECORD_TYPE_DONUT_TITLE = isRecordTypeVisible(APP_RECORD_TYPES.IT_SERVICE)
  ? "Applications and IT Services"
  : "Applications";

export function addApplicationsByRecordTypeCard(
  view: View<TestAppState, DragAndDropLayout>
): void {
  const applicationsByRecordTypeComponent = view.addComponent({
    component: PMDonutChartCard,
    layoutProps: {
      componentId: "applicationsByRecordTypeDashboardComponent",
      labels: ["donutChart", "chart", "recordType"],
      description:
        "Shows the distribution of tracking items by record type across all projects.",
      title: RECORD_TYPE_DONUT_TITLE,
    },
  });

  applicationsByRecordTypeComponent.mapState(({ dashboard }) => {
    const allItems = getAllReportingItems(dashboard);

    return {
      title: withTotalInTitle(RECORD_TYPE_DONUT_TITLE, allItems.length),
      icon: "DonutLarge",
      ...DONUT_CARD_LAYOUT,
      data: [
        {
          label: "DC Business Apps",
          value: countReportingItemsByRecordType(
            allItems,
            APP_RECORD_TYPES.BUSINESS_APPLICATION
          ),
          color: DONUT_CHART_COLORS[0],
        },
        ...(isRecordTypeVisible(APP_RECORD_TYPES.IT_SERVICE)
          ? [
              {
                label: "IT Services",
                value: countReportingItemsByRecordType(
                  allItems,
                  APP_RECORD_TYPES.IT_SERVICE
                ),
                color: DONUT_CHART_COLORS[1],
              },
            ]
          : []),
      ],
    };
  });
}
